import { IonNote, IonActionSheet, IonRippleEffect, IonModal, IonList, IonPopover, useIonRouter, useIonViewWillLeave, IonFooter, IonChip, useIonViewDidEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonText, IonThumbnail, IonBadge, IonImg, IonTextarea, IonProgressBar, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useRef, Component, useState, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { chatboxEllipsesOutline, trashBinOutline, lockOpenOutline, lockClosedOutline, createOutline, copyOutline, close, arrowRedoOutline, peopleOutline, imagesOutline, banOutline, trashOutline, listOutline, ellipsisVertical, walletOutline, imageOutline, closeOutline, personAdd, addOutline, sendOutline } from "ionicons/icons";
import { Keyboard } from '@capacitor/keyboard';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Clipboard } from '@capacitor/clipboard';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';

import './Main.css';
import './ChatMsg.css';

import { showTab, hideTab } from "../components/Tabs";
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';

import { MsgData, MsgDataGroup, MsgUser } from "../data/message";
import ChatMsgGroup from "../components/ChatMsgGroup";
import { showAlert } from '../components/Alert';
import GifContent, { LoadGifs, GifData } from "../components/GifContent";
import LikeErrComp from "../components/LikeErrComp";
import { ReadyAds, ShowAds } from "../components/Admob";

import ChatComp from "../components/ChatComp";
import ChatInput from "../components/ChatInput";


interface chatIDParam extends RouteComponentProps<{
    id : any,
    type : string
    }> 
{} 

const total = 30;
var maxIndex = -1;
var minIndex = Number.MAX_VALUE;
var rawMsgList : MsgData[] = [];
var refreshTimer : any;
var chat_type : string = "";
var block_user : number = -1;
var block_type : string = "";
var scroll_y = 0;
var counter : number = 0;

const ChatMsg2 : React.FC<chatIDParam> = ({match}) => {
    
    const [avatar, setAvatar] = useState("https://nwallet.me/img/avt.jpg");
    const [userID, setUserID] = useState(-1);
    const [name, setName] = useState("User");
    const [thread, setThread] = useState(-1);
    const [email, setEmail] = useState("");
    const [blocked, setBlocked] = useState(false);
    const [chatType, setChatType] = useState("");
    const [members, showMembers] = useState(false);
    const [closed, setClosed] = useState(false);
    const [repliedMsg, setRepliedMsg] = useState<any>(null);
    const [maxImages, setMaxImages] = useState(0);
    const [totalImages, setTotalImages] = useState(0);
    const [minWords, setMinWords] = useState(0);
    const [adminMode, setAdminMode] = useState(false);
    const [bk, setBK] = useState("");
    const [timer, setTimer] = useState(0);

    const [memberList, setMemberList] = useState<MsgUser[]>([]);

    const [deleteAsk, setDeleteAsk] = useState(false);
    const [blockAsk, setBlockAsk] = useState(false);
    const [offline, setOffline] = useState(false);
    const [tag, setTag] = useState("");
    
    const [headerInfo, showHeaderInfo] = useState(true);
    const [headerImg, setHeaderImg] = useState("");
    const [headerTitle, setHeaderTitle] = useState("");
    const [headerDesc, setHeaderDesc] = useState("");
    const [headerAction, setHeaderAction] = useState("");
    const [headerActionPath, setHeaderActionPath] = useState("");
    
    const [needJoin, setNeedJoin] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        counter = 0;

        // refresh in next 5 secs
        refreshTimer = setInterval(() => {
            updateChat();
        }, 5000);

        RegisterAppServices();

        hideTab();
    });

    useIonViewDidEnter(() => {
    });

    useIonViewWillLeave(() => {
        clearInterval(refreshTimer);
        showTab();
    });

    // for mobile only
    if (window.cordova)
    {
        Keyboard.addListener('keyboardDidShow', info => {
            // scroll UI to bottom
        });
    }

    // updare the chat message
    const updateChat = () => {
        counter += 1;
        setTimer(counter);
    }

    // set the server data
    const setServer = (server : any) => {
        // update the UI
        setUserID(server.data.user);
        setAvatar(server.data.avatar);
        setName(server.data.title);
        setThread(server.data.thread);
        setMemberList(server.data.members);
        setBlocked(server.data.blocked == 1);
        setChatType(server.data.chat_type);
            
        setClosed(server.data.closed == 1);
        setMaxImages(server.data.max_img);
        setTotalImages(server.data.total_img);
        setMinWords(server.data.min_words);
        setAdminMode(server.data.admin == 13);
        setBK(server.data.bk);
        setNeedJoin(server.data.need_join == 1);

        // set the header actions
        setHeaderImg(server.data.header.img);
        setHeaderTitle(server.data.header.title);
        setHeaderDesc(server.data.header.desc);
        setHeaderAction(server.data.header.action);
        setHeaderActionPath(server.data.header.path);
    }

    // send the message
    const deleteMsg = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: match.params.id,
            type : match.params.type
        }

		var server = new NServer();
        await server.sendForm("del_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/messages", "back", "pop");
            window.location.reload();
        }
    }

    // block the user
    const blockUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: block_user,
            type : block_type
        }

		var server = new NServer();
        await server.sendForm("block", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/messages", "back", "pop");
            window.location.reload();
        }
    }

    // show the user
    const showUser = () => {
        if (userID > 0)
            router.push("/user/" + userID, "forward", "push");
    }

    // show the user
    const showMember = (m : number) => {
        showMembers(false);
        if (m > 0)
            router.push("/user/" + m, "forward", "push");
    }

    // block members
    const blockMember = (m : number) => {
        showMembers(false);

        block_user = m;
        block_type = "user";
        setBlockAsk(true);
    }

    // block the chat user
    const blockChatUser = () => {
        block_user = match.params.id;
        block_type = match.params.type;
        setBlockAsk(true);
    }

    // close the channel
    const closeChannel = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            other : match.params.id,
            type : match.params.type
        }

		var server = new NServer();
        await server.sendForm("close_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            updateChat();
        }
    }

    // add as a post
    const addAsPost = () => {

    }

    // upload the background
    const uploadBackground = async () => {
        if (thread < 0 || !adminMode)
            return;

        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri
        });

        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        var imageUrl = image.webPath;
        if (imageUrl == undefined)
            return;

        // upload image
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            name: thread,
            type: "ncbk"
        }

        var server = new NServer();
        await server.uploadImage(imageUrl, state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            updateChat();
        }
    }

    // clear the chat background
    const clearChatBackground = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            other : match.params.id,
            type : match.params.type
        }

		var server = new NServer();
        await server.sendForm("clear_chat_bk", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setBK("");
            updateChat();
        }
    }

    // change the name
    const changeName = () => {
        router.push("/change_chat_name", "forward", "push");
    }

    // click on the header action button
    const headerActionClick = () => {
        // check the type of action
        if (headerActionPath.substring(0, 5) == 'https')
            // open the browser
            window.open(headerActionPath);
        else
            router.push(headerActionPath, 'forward', 'push');
    }

    return (
       <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="ion-no-padding">
                        {
                            match.params.id >= 0 ?
                        <IonItem className="chat-header" lines="none" color="none" onClick={showUser}>
                            <IonAvatar slot="start">
                                <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                            </IonAvatar>
                            <IonLabel>
                                {tag}{name}
                            </IonLabel>
                        </IonItem>
                            :
                        <IonItem className="chat-header" lines="none">
                            <IonIcon slot="start" icon={personAdd} />
                            <IonInput placeholder={ GetStr(LANGUAGE.TXT_CHAT_EMAIL_INPUT) } onIonChange={ (e:any) => { setEmail(e.detail.value.toString()); } }/>
                        </IonItem>
                        }
                    </IonTitle>
                    {
                        match.params.id > 1 ?
                    <IonButton id="menu-but" fill="clear" slot="end"><IonIcon slot="start" icon={ellipsisVertical} /></IonButton>
                        :
                    <div />
                    }
                    <IonPopover trigger="menu-but" reference="event" dismissOnSelect={true}>
                        <IonContent>
                            <IonList>
                                <IonItem button={true} detail={false} onClick={ () => showMembers(true) } lines="none">
                                    <IonIcon slot="start" icon={peopleOutline} />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_MEMBER_LIST) }</IonLabel>
                                </IonItem>
                                <IonItem button={true} detail={false} onClick={ ()=> {setDeleteAsk(true)} } lines="none">
                                    <IonIcon slot="start" icon={trashOutline} />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_CHAT_DELETE) }</IonLabel>
                                </IonItem>
                                <IonItem button={true} detail={false} onClick={ blockChatUser } lines="none">
                                    <IonIcon slot="start" icon={banOutline} />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_CHAT_BLOCK) }</IonLabel>
                                </IonItem>
                                <IonItem button={true} detail={false} routerLink="/blocklist" lines="none">
                                    <IonIcon slot="start" icon={listOutline} />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_BLOCK_LIST) }</IonLabel>
                                </IonItem>
                                {
                                    chatType == "live" && adminMode ?
                                <IonItem button={true} detail={false} lines="none" onClick={ changeName }>
                                    <IonIcon slot="start" icon={ chatboxEllipsesOutline } />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_CHAT_CHANGE_NAME) }</IonLabel>
                                </IonItem>
                                    :
                                <div/>
                                }
                                {
                                    chatType == "live" && adminMode ?
                                    ( bk == "" ?
                                <IonItem button={true} detail={false} lines="none" onClick={ uploadBackground }>
                                    <IonIcon slot="start" icon={ imageOutline } />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_CHAT_UPLOAD_BK) }</IonLabel>
                                </IonItem>
                                    :
                                <IonItem button={true} detail={false} lines="none" onClick={ clearChatBackground }>
                                    <IonIcon slot="start" icon={ trashBinOutline } />
                                    <IonLabel>{ GetStr(LANGUAGE.TXT_CHAT_CLEAR_BK) }</IonLabel>
                                </IonItem>
                                )
                                    :
                                <div/>
                                }
                                {
                                    chatType == "live" && adminMode ?
                                <IonItem button={true} detail={false} lines="none" onClick={ closeChannel }>
                                    <IonIcon slot="start" icon={ closed ? lockOpenOutline : lockClosedOutline } />
                                    <IonLabel>{ GetStr(closed ? LANGUAGE.TXT_MSG_OPEN_CHANNEL : LANGUAGE.TXT_MSG_CLOSE_CHANNEL) }</IonLabel>
                                </IonItem>
                                    :
                                <div/>
                                }
                            </IonList>
                        </IonContent>
                    </IonPopover>
                    {
                        offline ?
                    <div className="ion-text-center"><IonText color="medium"><small>{ GetStr(LANGUAGE.TXT_OFFLINE) }</small></IonText></div>
                        :
                    <div />
                    }
                </IonToolbar>
                {
                    headerImg != "" ?
                <div>
                {
                    /* header display */
                    headerInfo ?
                <div className="chatbox-header">
                    <IonCard className="flat-card">
                        <IonItem lines="none">
                            <IonThumbnail slot="start">
                                <img className="round-thumb" src={ headerImg } onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                            </IonThumbnail>
                            <IonLabel>
                                <div className="msg-thread"><b>{ headerTitle }</b></div>
                                <IonNote className="ion-text-nowrap">{ headerDesc }</IonNote>
                            </IonLabel>
                        </IonItem>
                        <IonButton className="main-but" expand="block" fill="clear" onClick={ headerActionClick }>
                            <b>{ headerAction }</b>
                        </IonButton>
                    </IonCard>
                    <IonButton className="header-hide-but" fill="clear" onClick={ ()=> showHeaderInfo(false) }>
                        <small><b>Hide</b></small>
                    </IonButton>
                </div>
                    :
                <div>
                    <IonButton className="header-hide-but" fill="clear" onClick={ ()=> showHeaderInfo(true) }>
                        <small><b>Show</b></small>
                    </IonButton>
                </div>
                }
                </div>
                    :
                <div/>
                }
            </IonHeader>
            <IonContent id="msg-content" className="chat-bk" scrollY={false} >
                <IonAlert
                    isOpen={deleteAsk}
                    onDidDismiss={() => setDeleteAsk(false)}
                    header={GetStr(LANGUAGE.TXT_DELETE_CHAT_TITLE)}
                    message={GetStr(LANGUAGE.TXT_DELETE_CHAT_DESC)}
                    buttons={[
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            role: 'cancel',
                            cssClass: 'secondary',
                            id: 'cancel-button'
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_OK),
                            id: 'confirm-button',
                            handler: () => {
                                deleteMsg();
                            }
                        }
                    ]}
                />
                <IonAlert
                    isOpen={blockAsk}
                    onDidDismiss={() => setBlockAsk(false)}
                    header={GetStr(LANGUAGE.TXT_BLOCK_CHAT_TITLE)}
                    message={GetStr(LANGUAGE.TXT_BLOCK_CHAT_DESC)}
                    buttons={[
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            role: 'cancel',
                            cssClass: 'secondary',
                            id: 'cancel-button'
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_OK),
                            id: 'confirm-button',
                            handler: () => {
                                blockUser();
                            }
                        }
                    ]}
                />
                
                <ChatComp 
                    id={match.params.id}
                    type={match.params.type}
                    bk={bk}
                    timer={timer}
                    setServer={setServer}
                    setRepliedMsg={setRepliedMsg}
                />
            </IonContent>
            <IonFooter>
                <ChatInput id={match.params.id} type={match.params.type} 
                    thread={thread} need_join={needJoin} 
                    replied_msg={repliedMsg}
                    block={blocked}
                    max_images={maxImages}
                    total_images={totalImages}
                    minWords={minWords} 
                    email={email}
                    updateChat={updateChat}
                    chatType={chatType} 
                    closed={closed}
                >
                </ChatInput>
            </IonFooter>
            { /* member list */ }
            <IonModal
                isOpen={members}
                initialBreakpoint={ 1 }
                onDidDismiss={() => showMembers(false)}>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonItem lines="none">
                            <IonIcon slot="start" icon={peopleOutline} />
                            <IonLabel>{ GetStr(LANGUAGE.TXT_MEMBER_LIST) }</IonLabel>
                        </IonItem>
                        <IonButtons slot="end">
                            <IonButton onClick={()=>{showMembers(false)}}>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        <IonList>
                            { 
                                memberList.map( (m) => 
                                    <IonItem key={m.id} className="ion-activatable ripple-parent" lines="none" color="none">
                                        <IonAvatar slot="start" onClick={ ()=> showMember(m.id) }>
                                            <img src={m.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                                        </IonAvatar>
                                        <IonLabel className="ion-text-wrap" onClick={ ()=> showMember(m.id) }>
                                            <h2>{m.name}</h2>
                                        </IonLabel>
                                        <IonButton className="main-but" slot="end" onClick={ ()=> blockMember(m.id) }>{ GetStr(LANGUAGE.TXT_CHAT_BLOCK) }</IonButton>
                                        <IonRippleEffect></IonRippleEffect>
                                    </IonItem>
                                )
                            }
                        </IonList>
                    </IonContent>
                </div>
            </IonModal>
        </IonPage>
  );
};

export default ChatMsg2;
